import { SpaceBetween, Button } from "@cloudscape-design/components-themed";
import { showModal } from "./modal/modal-slice";
import { useAppDispatch } from "../../app/hook";

interface Action {
  label: string;
  disableFlg: boolean;
  fn: VoidFunction;
  showModalFlg: boolean;
}

interface ActionProps {
  actions: Action[];
  refetch: Function;
}

const ActionBtns = ({ actions }: ActionProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const handleActionBtnOnClick = (
    content: string,
    fn: VoidFunction,
    showModalFlg: boolean
  ) => {
    showModalFlg
      ? dispatch(
          showModal({
            content: `画面の内容で${content}します。`,
            positiveFn: fn,
          })
        )
      : fn();
  };
  return (
    <SpaceBetween size="m" direction="horizontal">
      {actions.map((action, index) => (
        <Button
          key={index}
          variant={index === actions.length - 1 ? "primary" : "normal"}
          disabled={action.disableFlg}
          onClick={() =>
            handleActionBtnOnClick(action.label, action.fn, action.showModalFlg)
          }
        >
          {action.label}
        </Button>
      ))}
    </SpaceBetween>
  );
};

export default ActionBtns;
